import { useState, useCallback } from 'react';

/**
 * Custom hook to gracefully handle image loading errors in Remotion compositions.
 * Prevents video crashes when external images fail to load.
 *
 * @returns Object with error state and error handler callback
 */
export const useImageErrorHandler = () => {
  const [hasError, setHasError] = useState(false);

  const handleError = useCallback((imageUrl?: string) => {
    if (imageUrl) {
      console.warn(`Failed to load image: ${imageUrl}`);
    }
    setHasError(true);
  }, []);

  return { hasError, handleError };
};
